<template>
    <div>
        <vc-left-menu></vc-left-menu>

        <div :class="{ 'layout-content': true, 'is-active': !getMenuToggle }">
            <div class="page-header-container">
                <div class="page-header clearfix">
                    <h3 class="page-title">{{ $t('words.basic_info') }}<span class="page-header-breadcrumb">></span>{{ $t('words.service_account') }}</h3>
                </div>
                <ul class="nav nav-tab nav--tab" id="childTab" role="tablist">
                    <li class="nav-item">
                        <router-link class="nav-link" :to="{ name: 'cms-preferences-general' }" aria-controls="general" aria-selected="false">{{ $t('words.contract_info') }}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link  class="nav-link active" :to="{ name: 'cms-preferences-service_account' }" aria-controls="service_account" aria-selected="false">{{ $t('words.service_account')}}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link  class="nav-link" :to="{ name: 'cms-preferences-login_account' }" aria-controls="login_account" aria-selected="false">{{ $t('words.login_account') }}</router-link>
                    </li>
                </ul>
            </div>
            <div class="module">
                <div class="module-body">
                    <form role="form" method="POST" @submit.prevent="doSubmit">
                        <h5 class="form__subtitle">{{ $t('words.service_account') }}</h5>
                        <div class="form-group row">
                            <label class="col-md-3 col-form-label" for="title">{{ $t('words.service_account_name') }}</label>
                            <div class="col-md-9">
                                <input type="text" id="name" name="name" maxlength="80"  :placeholder="$t('paragraphs.placeholder_service_account_name')" :class="{'form-control':true, 'is-invalid':meta.errors.name}" v-model="service_account.name" />
                                <span class="form-control--comment">{{ $t('paragraphs.invalid_service_account_input') }}</span>
                                <span class="invalid-feedback"  v-for="error in meta.errors.name" :key="error">{{ error }}</span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-md-3 col-form-label" for="key">{{ $t('words.service_account_key') }}</label>
                            <div class="col-md-9">
                                <input type="text" id="key" name="key" disabled :class="{'form-control':true, 'is-invalid':meta.errors.key}" v-model="service_account.key" />
                                <span class="invalid-feedback" v-if="meta.errors.key" v-for="error in meta.errors.key" :key="error">{{ error }}</span>
                            </div>
                        </div>
                        <h5 class="form__subtitle">{{ $t('words.custom_key') }}</h5>
                        <div class="form-group row">
                            <label class="col-md-3 col-form-label" for="security_key">{{ $t('words.security_key') }}</label>
                            <div class="col-md-9">
                                <input type="text" id="security_key" name="security_key" disabled="true" class="form-control" v-model="service_account.security_key" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 col-form-label" for="custom_key">{{ $t('words.custom_key') }}</label>
                            <div class="col-md-9">
                                <input type="text" id="custom_key" name="custom_key" disabled="true" class="form-control" v-model="service_account.custom_key" />
                            </div>
                        </div>
                    </form>
                </div>
                <div class="module-footer">
                    <button type="submit" class="btn btn-lg btn-primary" v-if="haveSubmitRight" @click.prevent="doSubmit">
                        {{ $t('words.save') }}
                    </button>
                </div>
            </div>

            <div class="module">
                <passport-clients :haveSubmitRight="haveSubmitRight"></passport-clients>
            </div>

            <div class="module">
                <passport-authorized-clients :haveSubmitRight="haveSubmitRight"></passport-authorized-clients>
            </div>

            <div class="module">
                <passport-personal-access-tokens :haveSubmitRight="haveSubmitRight"></passport-personal-access-tokens>
            </div>
        </div>
    </div>
</template>
<script>
import GlobalConfigMixin from '../mixin/GlobalConfigMixin';
import passportClients from './oauth/Clients.vue';
import passportAuthorizedClients from './oauth/AuthorizedClients.vue';
import passportPersonalAccessTokens from './oauth/PersonalAccessTokens.vue';

export default {
    mixins: [
        GlobalConfigMixin,
    ],
    components: {
        passportClients,
        passportAuthorizedClients,
        passportPersonalAccessTokens,
    },
    data() {
        return {
            service_account: {

            },
            meta: {
                errors: {},
            },
        };
    },
    beforeMount() {
    },
    mounted() {
        if (this.loadedServiceAccount) {
            this.initialize();
        }
    },
    methods: {
        initialize() {
            axios.get(this.serviceAccountApiUri).then((response) => {
                this.service_account = response.data.data;
            });
        },
        doSubmit() {
            if (!this.haveSubmitRight) {
                this.$toasted.error(this.$t('paragraphs.error.check_login_right'));
                return;
            }

            const confirmMessage = this.$t('paragraphs.message.confirm.update_item');
            if (confirm(confirmMessage)) {
                axios.put(`${this.serviceAccountApiUri}`, _.pick(this.service_account, [
                    'name',
                ])).then(() => {
                    this.meta.errors = {};
                    this.$toasted.success(this.$t('paragraphs.message.success.update'));
                }).catch((error) => {
                    this.meta.errors = error.response.data.errors;
                    this.$toasted.error(this.$t('paragraphs.message.error.update'));
                });
            }
        },
    },
    computed: {
        serviceAccountApiUri() {
            return `/cms/${this.selectedServiceAccount.key}/service_account`;
        },
        haveSubmitRight() {
            return this.haveOwnerRight;
        },
    },
    watch: {
        loadedServiceAccount(newValue) {
            this.initialize();
        },
    },
};
</script>

<style scoped>

</style>
